import { MotionValue, useSpring } from 'framer-motion'
import { useCallback, useEffect, useState } from 'react'

type AnimationObject = {
  isMounted: boolean
  opacity: MotionValue
  scale: MotionValue
  mountAnimation: () => void
  unmountAnimation: () => void
}

const springConfig = { damping: 25, stiffness: 300 }
const initialScale = 0.75

export const usePopoverAnimation = (): AnimationObject => {
  const [isMounted, setIsMounted] = useState(false)
  const opacity = useSpring(0, springConfig)
  const scale = useSpring(initialScale, springConfig)

  const mountAnimation = useCallback(() => {
    setIsMounted(true)
    scale.set(1)
    opacity.set(1)
  }, [scale, opacity])

  const unmountAnimation = useCallback(() => {
    scale.set(initialScale)
    opacity.set(0)
  }, [scale, opacity])

  useEffect(() => {
    const unsubscribe = opacity.onChange((value) => {
      if (value === 0) {
        setIsMounted(false)
      }
    })

    return () => {
      unsubscribe()
    }
  }, [opacity])

  return {
    isMounted,
    opacity,
    scale,
    mountAnimation,
    unmountAnimation,
  }
}
